import React from 'react';
import { Row, Col } from 'antd';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import InvoiceBillingInfo from './billing-info';
import ReconciliationSetting from './reconciliation-set';
import InvoiceDetails from './invoice-details';

const useStyles = makeStyles(() => ({
  cardContainer: {
    marginBottom: 24,
  },
}));

const LandlordInVoiceInfo = props => {
  const { landlord, getLandlord, updateLandlord } = props;
  const classes = useStyles();
  return (
    <Row>
      <Col span={24} className={classes.cardContainer}>
        <InvoiceBillingInfo
          landlord={landlord}
          getLandlord={getLandlord}
          updateLandlord={updateLandlord}
        />
      </Col>
      <Col span={24} className={classes.cardContainer}>
        <ReconciliationSetting
          landlord={landlord}
          getLandlord={getLandlord}
          updateLandlord={updateLandlord}
        />
      </Col>
      <Col span={24} className={classes.cardContainer} style={{ marginBottom: 0 }}>
        <InvoiceDetails
          landlord={landlord}
          getLandlord={getLandlord}
          updateLandlord={updateLandlord}
        />
      </Col>
    </Row>
  );
};
LandlordInVoiceInfo.propTypes = {
  landlord: PropTypes.object.isRequired,
  getLandlord: PropTypes.func.isRequired,
  updateLandlord: PropTypes.func.isRequired,
};
export default LandlordInVoiceInfo;
